import * as React from 'react';
import * as styles from './ListItem.css';
import { Checkbox, Image, IconImage16 } from '@cian/ui-kit';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ListItem(_ref) {
  var id = _ref.id,
    imageUrl = _ref.imageUrl,
    name = _ref.name,
    description = _ref.description,
    selected = _ref.selected,
    onChange = _ref.onChange;
  var handleChange = function handleChange(e) {
    e.preventDefault();
    e.stopPropagation();
    onChange(id, !selected);
  };
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    onClick: handleChange,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['image'],
      children: imageUrl ? /*#__PURE__*/_jsx(Image, {
        src: imageUrl,
        width: 48,
        height: 48
      }) : /*#__PURE__*/_jsx(IconImage16, {
        color: "gray20_100"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles['body'],
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles['info'],
        children: [/*#__PURE__*/_jsx("div", {
          className: styles['name'],
          children: name
        }), /*#__PURE__*/_jsx("div", {
          className: styles['description'],
          children: description
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles['checkbox'],
        children: /*#__PURE__*/_jsx(Checkbox, {
          onChange: handleChange,
          checked: selected
        })
      })]
    })]
  });
}